import React from 'react';
import { SiteMemberRole } from '../../api/sitesV2Api';
import './RoleBadges.css';

interface RoleBadgesProps {
  roles?: SiteMemberRole[];
  fallbackRoleName?: string;
  className?: string;
}

/**
 * Компонент для отображения ролей участника
 * Показывает все активные роли в виде ярлычков, или fallback роль если ролей нет
 */
export const RoleBadges: React.FC<RoleBadgesProps> = ({ 
  roles, 
  fallbackRoleName,
  className = ''
}) => {
  const activeRoles = roles?.filter(r => r.isActive) || [];

  if (activeRoles.length > 0) {
    return (
      <div className={`role-badges ${className}`}>
        {activeRoles.map((role) => (
          <span key={role.id} className="role-badge">
            {role.roleName || `Роль ${role.roleId}`}
          </span>
        ))}
      </div>
    );
  }

  // Fallback на старую роль если новых ролей нет
  if (fallbackRoleName) {
    return (
      <div className={`member-role ${className}`}>
        {fallbackRoleName}
      </div>
    );
  }

  return (
    <div className={`member-role ${className}`}>
      Роль не назначена
    </div>
  );
};

export default RoleBadges;

